<template>
  <div class="pdv-client-panel">
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
      <el-divider content-position="left">Dados do cliente</el-divider>
      <el-row class="delivery-selector-row">
        <el-col :xs="24" :sm="12" :md="10">
          <el-form-item :label="$t('nome')" prop="name" class="is-required">
            <el-autocomplete tabindex="0" v-model="ruleForm.name" :fetch-suggestions="queryClients"
              :trigger-on-focus="false"
              @select="selectClient" v-on:keyup.native.enter="next" maxlength="80" ref="name"
              data-next="phone"></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="5">
          <el-form-item :label="$t('telefone')" prop="phone" class="is-required">
            <el-input v-model="ruleForm.phone" v-mask="['(##) ####-####', '(##) #####-####']" v-on:keyup.native.enter="next"
              ref="phone" data-next="mail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="7">
          <el-form-item :label="$t('email')" prop="mail">
            <el-input v-model="ruleForm.mail" type="mail" maxlength="120" v-on:keyup.native.enter="next"
              ref="mail"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="3" class="client-save-col">
          <el-button class="client-save-button" type="primary" title="Salva o cliente no sistema" @click="save()">
            <i class="fa fa-floppy-o" aria-hidden="true"></i>
            Salvar
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ZipMixins from "@/xpost/mixins/zipcode";
import { PdvClientService } from "@/services/pdv/pdv.client.services";
export default {
  mixins: [ZipMixins],
  name: "PdvCallSender",
  data() {
    return {
      clients: [],
      ruleForm: {
        name: '',
        phone: '',
        mail: '',
      }
    }
  },
  mounted() {
    this.fetchClients();
  },
  methods: {
    startup(form) {
      this.ruleForm = form;
    },
    fetchClients() {
      const vm = this;
      PdvClientService.list()
        .then((response) => {
          vm.clients = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    queryClients(queryString, cb) {
      const search = (queryString || '').toLowerCase();
      cb(
        this.clients
          .filter((x) => !search || x.name.toLowerCase().includes(search))
          .map((x) => ({ value: x.name, client: x }))
      );
    },
    selectClient(item) {
      this.ruleForm.phone = item.client.phone;
      this.ruleForm.mail = item.client.mail || '';
    },
    save() {
      const vm = this;
      if (!vm.ruleForm.name || !vm.ruleForm.phone) {
        this.$message({
          type: "warning",
          message: "Informe nome e telefone para salvar o cliente!",
          duration: 5000,
        });
        return;
      }
      const loading = vm.$loading(vm.$options.loading);
      PdvClientService.add({
        name: vm.ruleForm.name,
        phone: vm.ruleForm.phone,
        mail: vm.ruleForm.mail,
      })
        .then(() => {
          vm.fetchClients();
          this.$message({
            type: "success",
            message: "Cliente salvo com sucesso!",
            duration: 5000,
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    next(el, ev) {
      if (el.target.dataset.next && this.$refs[el.target.dataset.next]) {
        this.$refs[el.target.dataset.next].$el.getElementsByTagName('input')[0].focus();
      } else {
        this.$emit('focus');
      }
    },
    focus() {
      this.$refs.name.$el.getElementsByTagName('input')[0].focus();
    },
    clear() {
      this.ruleForm = {
        name: '',
        phone: '',
        mail: '',
      }
    },
    back() {
      this.$router.replace({
        name: 'pdv',
      })
    }
  }
};
</script>

<style>
.btn-card {
  width: 180px;
  height: 100px;
}

.icon-large {
  height: 40px;
}
</style>

<style scoped>
/* Destaca o bloco do cliente — primeiro passo do atendimento, costuma ser esquecido */
.pdv-client-panel {
  padding: 0 24px;
  margin-bottom: 20px;
}

.pdv-client-panel >>> .el-autocomplete,
.pdv-client-panel >>> .el-input {
  width: 100%;
}

.client-save-col {
  flex: 0 0 110px;
  float: none;
  max-width: 110px;
}

.client-save-button {
  width: 100%;
}

.delivery-selector-row {
  align-items: center;
  display: flex;
  gap: 12px;
  width: 100%;
}

@media (max-width: 767px) {
  .client-save-col {
    flex-basis: auto;
    max-width: none;
    width: 100%;
  }

  .delivery-selector-row {
    align-items: stretch;
    flex-direction: column;
  }
}
/* o título da seção fica em largura total; só o conteúdo recebe recuo */
.pdv-client-panel >>> .el-divider--horizontal {
  margin-left: -24px;
  margin-right: -24px;
  width: auto;
}

.pdv-client-panel >>> .el-divider__text {
  font-weight: 600;
  color: #303133;
}
</style>